import { Controller } from '@hotwired/stimulus';

/** Reveal optional form fields on demand (e.g. fallback cover URL). */
export default class extends Controller {
  static targets = ['panel', 'trigger', 'clearField'];

  show(event) {
    event.preventDefault();
    this.panelTarget.hidden = false;
    this.triggerTarget.hidden = true;

    const input = this.panelTarget.querySelector('input[type="url"], input[type="text"]');
    input?.focus();
  }

  hide(event) {
    event.preventDefault();
    if (this.hasClearFieldTarget) {
      this.clearFieldTarget.value = '';
    }

    this.panelTarget.hidden = true;
    this.triggerTarget.hidden = false;
  }
}
